import React, { useState } from "react";
// import { useLocation } from "react-router-dom";
import { API_URL } from "../../Config.js";

const GetInTouch = () => {
  //   const location = useLocation();

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [emailSuccess, setEmailSuccess] = useState("");

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });
  const [contactError, setContactError] = useState("");
  const [contactSuccess, setContactSuccess] = useState("");

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailSubmit = (e) => {
    e.preventDefault();
    if (validateEmail(email)) {
      setEmailError("");
      setEmailSuccess("You have subscribed successfully!");
      console.log("Email submitted:", email);
      setEmail("");
      setTimeout(() => {
        setEmailSuccess("");
      }, 20000);
    } else {
      setEmailError("Please enter a valid email address.");
      setEmailSuccess("");
      setEmail("");
      setTimeout(() => {
        setEmailError("");
      }, 8000);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone") {
      const cleanedValue = value.replace(/\D/g, "");
      const limitedValue = cleanedValue.slice(0, 10);

      setFormData((prevState) => ({
        ...prevState,
        [name]: limitedValue,
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const validateEmailInForm = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhoneNumber = (phone) => {
    const phoneRegex = /^\d{10}$/;
    return phoneRegex.test(phone);
  };

  const validateContactForm = () => {
    let formErrors = {};

    if (!formData.firstName.trim()) {
      formErrors.firstName = "First name is required.";
    }
    if (!formData.lastName.trim()) {
      formErrors.lastName = "Last name is required.";
    }
    if (!validateEmailInForm(formData.email)) {
      formErrors.email = "Please enter a valid email address.";
    }
    if (!validatePhoneNumber(formData.phone)) {
      formErrors.phone = "Please enter a valid phone number (10 digits).";
    }
    if (
      Object.keys(formErrors).length === 0 &&
      (!formData.firstName.trim() ||
        !formData.lastName.trim() ||
        !formData.email ||
        !formData.phone ||
        !formData.message.trim())
    ) {
      return { general: "Please fill out all fields." };
    }

    return formErrors;
  };

  const handleContactSubmit = (e) => {
    e.preventDefault();
    const formErrors = validateContactForm();

    if (formErrors.general) {
      setContactError(formErrors.general);
      setContactSuccess("");
      console.log("Form submission error:", formErrors.general);
    } else if (Object.keys(formErrors).length > 0) {
      setContactError(Object.values(formErrors).join(" "));
      setContactSuccess("");
      console.log("Form submission errors:", formErrors);
    } else {
      // Send form data to the backend
      fetch(API_URL + "/send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.message) {
            setContactSuccess("Your response has been sent successfully!");
            console.log("Email sent successfully:", data.message);
            // openPopup_thankYou();
          } else {
            setContactError("Failed to send email");
          }
        })
        .catch((error) => {
          console.error("Error sending email:", error);
          setContactError("Failed to send email");
        });

      // Clear the form
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
      });

      // Reset error/success messages after a timeout
      setTimeout(() => {
        setContactError("");
        setContactSuccess("");
      }, 8000);
    }
  };

  // const [isPopup_thankYou, setPopup_thankYou] = useState(false);

  // const openPopup_thankYou = () => {
  //   setPopup_thankYou(true);
  // };

  // const closePopup_thankYou = () => {
  //   setPopup_thankYou(false);
  // };

  return (
    <div>
      <div className="px-5 lg:px-[7%] 2xl:px-[13%] py-10">
        <div className="bg-gray-50 dark:bg-[#252525] rounded-lg p-5 md:p-10 transition-all duration-300 ease-in-out">
          <h6 className="font-semibold text-3xl lg:text-4xl transition-all duration-200 ease-in-out">
            Sign Up For Weekly Reads!
            <div className="flex h-0.5 w-10 mt-0.5 bg-teal-600 rounded-full" />
          </h6>

          <form
            className="flex flex-col items-center justify-center mt-8"
            required
          >
            <span id="contact-us" />
            <div className="flex flex-row gap-2">
              <input
                className="text-black w-[60vw] md:w-[50vw] lg:w-[40vw] p-1 md:p-2 rounded-md outline-none border border-gray-200"
                type="text"
                placeholder="Enter your email"
                value={email}
                onChange={handleEmailChange}
                required
              />

              <div className="relative group">
                <button
                  className="relative inline-block p-px text-white bg-[#008080] cursor-default rounded-lg shadow-emerald-900 transition-all duration-300 ease-in-out hover:scale-105 active:scale-95 hover:shadow-emerald-600"
                  onClick={handleEmailSubmit}
                  type="submit"
                >
                  <span className="absolute inset-0 rounded-lg bg-gradient-to-r from-teal-100 via-teal-300 to-teal-500 p-[2px] opacity-0 transition-opacity duration-500 group-hover:opacity-100"></span>
                  <span className="relative z-10 block px-4 py-2 rounded-lg bg-[#008080]">
                    <div className="relative z-10 flex items-center space-x-3">
                      <span className="font-medium transition-all duration-500 group-hover:translate-x-0 text-sm group-hover:text-white">
                        Sign up
                      </span>
                    </div>
                  </span>
                </button>
              </div>
            </div>
            {emailError && <p className="text-red-500 mt-2">{emailError}</p>}
            {emailSuccess && (
              <p className="text-green-500 mt-2">{emailSuccess}</p>
            )}
            <span id="ContactUs"></span>

            <p className="text-[12px] leading-5 mt-3 text-center w-72 md:w-full">
              By clicking Sign Up you're confirming that you agree with
              our&nbsp;
              <a
                href="/terms-and-conditions"
                className="underline hover:text-[#008080]"
              >
                Terms and Conditions.
              </a>
            </p>
          </form>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-[250px_auto] lg:grid-cols-[30%_70%] mt-20 mb-14 transition-all duration-200 ease-in-out">
          <div className="mx-5 md:mx-0 md:my-10 z-10">
            <div className="flex h-full md:justify-center items-center bg-[#008080] p-10 rounded-lg">
              <h6 className="font-semibold text-white text-3xl lg:text-4xl transition-all duration-200 ease-in-out">
                Get In Touch <br /> With Us!
                <div className="flex h-0.5 w-10 mt-0.5 bg-teal-600 rounded-full" />
              </h6>
            </div>
          </div>

          <div className="shadow-custom dark:shadow-white p-5 md:p-10 pt-28 md:pt-20 md:pb-10 md:pl-40 md:-ml-32 -mt-20 md:mt-0 transition-all duration-200 ease-in-out">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-10">
              <div>
                <p className="text-sm font-semibold text-gray-500">
                  First Name
                </p>
                <input
                  className="p-2 w-full outline-none bg-transparent"
                  type="text"
                  name="firstName"
                  placeholder="Enter first name"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  required
                />
                <div className="h-[1px] w-full bg-[#008080]"></div>
              </div>

              <div>
                <p className="text-sm font-semibold text-gray-500">Last Name</p>
                <input
                  className="p-2 w-full outline-none bg-transparent"
                  type="text"
                  name="lastName"
                  placeholder="Enter last name"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  required
                />
                <div className="h-[1px] w-full bg-[#008080]"></div>
              </div>

              <div>
                <p className="text-sm font-semibold text-gray-500">Email</p>
                <input
                  className="p-2 w-full outline-none bg-transparent"
                  type="text"
                  name="email"
                  placeholder="Enter email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
                <div className="h-[1px] w-full bg-[#008080]"></div>
              </div>

              <div>
                <p className="text-sm font-semibold text-gray-500">Phone No.</p>
                <input
                  className="p-2 w-full outline-none bg-transparent"
                  type="text"
                  name="phone"
                  placeholder="Enter phone no."
                  pattern="\d{10}"
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                />
                <div className="h-[1px] w-full bg-[#008080]"></div>
              </div>

              <div className="sm:col-span-2">
                <p className="text-sm font-semibold text-gray-500">Message</p>
                <textarea
                  className="p-2 w-full outline-none bg-transparent"
                  type="text"
                  name="message"
                  placeholder="Enter message"
                  value={formData.message}
                  onChange={handleInputChange}
                />
                <div className="h-[1px] w-full bg-[#008080]"></div>
              </div>
            </div>

            {contactError && (
              <p className="text-red-500 mt-2 tex-center">{contactError}</p>
            )}
            {contactSuccess && (
              <p className="text-green-500 mt-2 text-center">
                {contactSuccess}
              </p>
            )}

            <div className="flex justify-end relative group mt-10">
              <button
                className="relative inline-block p-px text-white bg-[#008080] cursor-default rounded-lg shadow-emerald-900 transition-all duration-300 ease-in-out hover:scale-105 active:scale-95 hover:shadow-emerald-600"
                type="submit"
                onClick={handleContactSubmit}
              >
                <span className="absolute inset-0 rounded-lg bg-gradient-to-r from-teal-100 via-teal-300 to-teal-500 p-[2px] opacity-0 transition-opacity duration-500 group-hover:opacity-100"></span>
                <span className="relative z-10 block px-4 py-2 rounded-lg bg-[#008080]">
                  <div className="relative z-10 flex items-center space-x-3">
                    <span className="font-medium transition-all duration-500 group-hover:translate-x-0 text-sm group-hover:text-white">
                      Send a message
                    </span>
                  </div>
                </span>
              </button>
            </div>
          </div>
        </div>

        {/* {isPopup_thankYou && (
          <>
            <div
              className="overlay_Careers"
              onClick={closePopup_thankYou}
            ></div>
            <div className="popup_form_Careers">
              <span className="close_Careers" onClick={closePopup_thankYou}>
                &times;
              </span>
              <form>
                <div className="text-black">
                  <p className="text-lg md:text-2xl lg:text-lg 2xl:text-3xl font-semibold">
                    Thank you for your response!
                  </p>
                  <p className="mt-[2%]">
                    Your response has been successfully sent.
                  </p>

                  <div className="flex justify-end mt-[3%]">
                    <button
                      className="btn_careers"
                      onClick={closePopup_thankYou}
                    >
                      <span className="transition_btn_careers"></span>
                      <span className="gradient_btn_careers"></span>
                      <span className="label_btn_careers">Done</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </>
        )} */}
      </div>
    </div>
  );
};

export default GetInTouch;
